export default __webpack_public_path__ + "static/financial-software-development-company-peerbits-f84e8fe5d18472fc82eb0d68b5e85eb3.png";